import { render, staticRenderFns } from "./DevDocsForm.vue?vue&type=template&id=797d076a&"
import script from "./DevDocsForm.vue?vue&type=script&lang=js&"
export * from "./DevDocsForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports